import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamPaymentRequestMetricsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const getAllTeamPaymentRequestMetrics = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_REQUESTED, { pagination, compile });

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  getAllTeamPaymentRequestMetricsPending: (): any => action(types.GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_PENDING, { }),
  getAllTeamPaymentRequestMetricsSuccess: (response): any => action(types.GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_SUCCESS, {
    teamPaymentRequestMetricsById: response.entities.teamPaymentRequestMetrics,
    teamPaymentRequestMetricIds: [response.result],
    currentTeamPaymentRequestId: response.result,
  }),
  getAllTeamPaymentRequestMetricsFailed: (error): any => action(types.GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_FAIL, { backendErrors: error }),
};

export default null;
